import React from 'react'

const ErrorMessage = props => <div className="error-message">
    {props.title && <h2>{props.title}</h2>}
    {props.text}
    </div>

export default ErrorMessage 